export default "__VITE_ASSET__CEK_31Ek__"